import { inject, Injectable } from '@angular/core';
import { CONFIG_TOKEN } from '@pxl/models/common';
import { InsuranceClaimService, LoginService } from '@pxl/models/contracts';
import {
    InsuranceClaimService as InsuranceClaimBackendService,
    InsuranceClaimSubmissionModel,
    InsuranceClaimSubmissionResultModel,
    InsuranceclaimPolicyvalidationBody,
    InsuranceclaimSubmitBody,
    InsurancePolicyValidationModel,
} from '@pxl/shared/generated';
import { Observable } from 'rxjs';

/**
 * Tickets #55481/#55482: submits an invoice claim through the backend insurance-claim endpoint.
 *
 * Backend-only communication — the app never sees the insurer API key. One request carries every
 * selected pet's insurance; the backend fans out to one claim per pet and returns a per-pet result
 * array. Each result's status decides that pet's outcome (`Submitted` = success/"in review";
 * `Failed`/`Unknown` = unchanged, retriable). An HTTP error means nothing was transmitted.
 */
@Injectable({
    providedIn: 'root',
})
export class DefaultInsuranceClaimService implements InsuranceClaimService {
    private readonly backendService = inject(InsuranceClaimBackendService);
    private readonly config = inject(CONFIG_TOKEN);
    private readonly loginService = inject(LoginService);

    public submitClaim(claim: InsuranceclaimSubmitBody): Observable<InsuranceClaimSubmissionResultModel[]> {
        return this.backendService.submit(claim, this.config.API_VERSION, this.loginService.getToken() ?? '');
    }

    public getSubmissions(invoiceId: string): Observable<InsuranceClaimSubmissionModel[]> {
        return this.backendService.getSubmissions(this.config.API_VERSION, this.loginService.getToken() ?? '', [invoiceId]);
    }

    public validatePolicy(request: InsuranceclaimPolicyvalidationBody): Observable<InsurancePolicyValidationModel> {
        return this.backendService.validatePolicy(request, this.config.API_VERSION, this.loginService.getToken() ?? '');
    }
}
